export const columna = [

	

   {
		"nombre": "Noticias.",
		"imagen": 'noticias/requisitos.jpg',
	   "funcion": 'Revisa los requisitos de participación.',
		"url" : 'https://www.facebook.com/share/p/1BEHDNafE9',
	},


	{
		"nombre": "Noticias.",
		"imagen": 'noticias/podpueblo.jpg',
	    "funcion": 'El Podcast del Pueblo.',
		"url" : 'https://www.facebook.com/reel/1010296311625005',
	},

	
	{
		"nombre": "Noticias.",
		"imagen": 'noticias/sesenta.jpg',
	    "funcion": '60 segundos.',
		"url" : 'https://www.facebook.com/share/v/19te4PFRpq/',
	},

	{
		"nombre": "Noticias.",
		"imagen": 'noticias/buzón.jpg',
		"funcion": "Buzón Digital",
		"url": "https://buzondigitalcontraloria.hidalgo.gob.mx/"
	},

	// // {
	// 	"nombre": "Podcast del Pueblo",
	// 	"imagen": 'noticias/comisarios.jpg',
	// 	"funcion": '"Hidalgo Honesto"',
	// 	"url" : 'https://www.facebook.com/100064535929070/videos/755046710063599/?__so__=permalink&locale=es_LA',
	// },
		



]